<template>
  <v-container fluid tag="section" class="cyber-agenda">
    <v-row>
      <v-col cols="12" md="5">
        <base-material-card color="#018C74" icon="mdi-calendar-plus" class="glass-card">
          <template v-slot:heading>
            <div class="display-1 font-weight-black cyber-text">
              {{ editedItem.id ? "UPDATE PROTOKOL" : "PENJADWALAN BARU" }}
            </div>
            <div class="subtitle-2 secondary-text">
              Registrasi Agenda & Dokumentasi Terintegrasi
            </div>
          </template>

          <v-form ref="form" class="mt-4">
            <v-row dense>
              <v-col cols="12">
                <v-text-field
                  v-model="editedItem.nama_kegiatan"
                  label="Nama Kegiatan"
                  outlined
                  dense
                  color="#018C74"
                  prepend-inner-icon="mdi-clipboard-text-outline"
                />
              </v-col>

              <v-col cols="12">
                <p class="mb-2 caption secondary-text font-weight-bold">
                  <v-icon x-small color="#CFA22D">mdi-clock-fast</v-icon> PERIODE TANGGAL:
                </p>
                <div class="date-picker-wrapper">
                  <v-date-picker
                    v-model="dates"
                    range
                    full-width
                    color="#018C74"
                    class="cyber-datepicker"
                  ></v-date-picker>
                </div>
                <v-text-field
                  :value="dateRangeText"
                  label="Periode Terpilih"
                  prepend-inner-icon="mdi-calendar-range"
                  readonly
                  outlined
                  dense
                  class="mt-3 cyber-input-highlight"
                />
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  v-model="editedItem.jam_mulai"
                  label="Waktu Mulai"
                  type="time"
                  outlined
                  dense
                  color="#018C74"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="editedItem.lokasi"
                  label="Nama Lokasi"
                  outlined
                  dense
                  color="#018C74"
                />
              </v-col>

              <v-col cols="12">
                <p class="mb-2 caption secondary-text font-weight-bold">
                  KOORDINAT GEOSPASIAL:
                </p>
                <div class="map-container-mini">
                  <div id="map-kegiatan" class="mini-map"></div>
                  <div class="map-overlay-grid"></div>
                </div>
                <v-text-field
                  v-model="editedItem.latlong"
                  label="Lat, Long"
                  outlined
                  dense
                  readonly
                  class="mt-2 cyber-input-coord"
                  color="#018C74"
                />
              </v-col>

              <v-col cols="12">
                <v-file-input
                  v-model="files"
                  label="Upload Dokumentasi (Multiple)"
                  outlined
                  dense
                  multiple
                  prepend-icon=""
                  prepend-inner-icon="mdi-camera-iris"
                  counter
                  color="#018C74"
                />
              </v-col>

              <v-col cols="12" class="d-flex">
                <v-btn
                  v-if="editedItem.id"
                  text
                  color="#6b7b78"
                  class="mr-2"
                  @click="clearForm"
                  >BATAL</v-btn
                >
                <v-btn
                  color="#CFA22D"
                  block
                  @click="save"
                  :loading="loading"
                  class="cyber-save-btn"
                >
                  <v-icon left>mdi-broadcast</v-icon>
                  {{ editedItem.id ? "UPDATE" : "SIMPAN DATA" }}
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </base-material-card>
      </v-col>

      <v-col cols="12" md="7">
        <base-material-card
          color="#CFA22D"
          icon="mdi-format-list-bulleted"
          class="glass-card"
        >
          <template v-slot:heading>
            <div class="display-1 font-weight-black white--text">
              MONITORING AKTIFITAS
            </div>
          </template>

          <v-data-table
            :headers="headers"
            :items="kegiatanList"
            :loading="loading"
            class="cyber-table"
          >
            <template v-slot:item.waktu="{ item }">
              <div class="font-weight-bold">{{ formatDate(item.tanggal_mulai) }}</div>
              <div class="caption secondary-text">
                s/d {{ formatDate(item.tanggal_selesai) }}
              </div>
            </template>

            <template v-slot:item.foto="{ item }">
              <div class="avatar-stack">
                <v-avatar
                  size="30"
                  v-for="(img, i) in splitFoto(item.list_foto)"
                  :key="i"
                  class="stack-item shadow-glow"
                >
                  <v-img :src="`https://berkah.bondowosokab.go.id:5500/uploads/${img}`" />
                </v-avatar>
              </div>
            </template>

            <template v-slot:item.actions="{ item }">
              <v-btn icon color="#018C74" @click="editItem(item)" class="glow-hover mr-1">
                <v-icon small>mdi-pencil-box-outline</v-icon>
              </v-btn>
              <v-btn icon color="#ff5252" @click="deleteItem(item)" class="glow-hover">
                <v-icon small>mdi-delete-alert-outline</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
const BASE_URL = "https://berkah.bondowosokab.go.id:5500";

export default {
  data: () => ({
    loading: false,
    map: null,
    marker: null,
    dates: [],
    files: [],
    kegiatanList: [],
    headers: [
      { text: "LINIMASA", value: "waktu", width: "150" },
      { text: "AKTIFITAS", value: "nama_kegiatan" },
      { text: "LOKASI", value: "lokasi" },
      { text: "DOKUMEN", value: "foto", sortable: false },
      { text: "KENDALI", value: "actions", align: "end" },
    ],
    editedItem: {
      id: null,
      nama_kegiatan: "",
      tanggal_mulai: "",
      tanggal_selesai: "",
      jam_mulai: "08:00",
      lokasi: "",
      latlong: "",
    },
  }),

  computed: {
    dateRangeText() {
      return this.dates.length > 0 ? this.dates.join("  ~  ") : "Pilih Tanggal";
    },
  },

  mounted() {
    this.initMap();
    this.fetchKegiatan();
  },

  methods: {
    initMap() {
      setTimeout(() => {
        if (typeof L === "undefined") return;
        const bondowoso = [-7.9135, 113.8215];
        this.map = L.map("map-kegiatan", { zoomControl: false }).setView(bondowoso, 13);
        L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png").addTo(this.map);

        this.map.on("click", (e) => {
          const { lat, lng } = e.latlng;
          this.editedItem.latlong = `${lat.toFixed(6)},${lng.toFixed(6)}`;
          this.updateMarker(lat, lng);
        });
      }, 500);
    },

    updateMarker(lat, lng) {
      if (this.marker) this.map.removeLayer(this.marker);
      this.marker = L.marker([lat, lng], {
        icon: L.divIcon({
          className: "cyber-marker",
          html: `<div style="background:#CFA22D; width:12px; height:12px; border-radius:50%; box-shadow:0 0 10px #CFA22D;"></div>`,
        }),
      }).addTo(this.map);
    },

    async fetchKegiatan() {
      this.loading = true;
      try {
        const res = await axios.get(`${BASE_URL}/kegiatan`);
        if (res.data && res.data.response && res.data.response.data) {
          this.kegiatanList = res.data.response.data;
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },

    formatDate(d) {
      if (!d) return "-";
      return new Date(d).toLocaleDateString("id-ID");
    },

    splitFoto(str) {
      return str ? str.split(",") : [];
    },

    editItem(item) {
      const tglMulai = item.tanggal_mulai ? item.tanggal_mulai.split("T")[0] : "";
      const tglSelesai = item.tanggal_selesai
        ? item.tanggal_selesai.split("T")[0]
        : tglMulai;

      this.editedItem = Object.assign({}, item);
      this.dates = [tglMulai, tglSelesai];

      if (item.latlong) {
        const coords = item.latlong.split(",").map(Number);
        this.updateMarker(coords[0], coords[1]);
        this.map.setView(coords, 15);
      }
      window.scrollTo({ top: 0, behavior: "smooth" });
    },

    clearForm() {
      this.editedItem = {
        id: null,
        nama_kegiatan: "",
        jam_mulai: "08:00",
        lokasi: "",
        latlong: "",
      };
      this.dates = [];
      this.files = [];
      if (this.marker) this.map.removeLayer(this.marker);
    },

    async save() {
      if (this.dates.length < 1) return alert("Pilih tanggal!");
      this.loading = true;

      const sortedDates = [...this.dates].sort();
      const formData = new FormData();
      formData.append("nama_kegiatan", this.editedItem.nama_kegiatan);
      formData.append("tanggal_mulai", sortedDates[0]);
      formData.append("tanggal_selesai", sortedDates[1] || sortedDates[0]);
      formData.append("jam_mulai", this.editedItem.jam_mulai);
      formData.append("lokasi", this.editedItem.lokasi);
      formData.append("latlong", this.editedItem.latlong);

      if (this.files.length > 0) {
        this.files.forEach((f) => formData.append("foto", f));
      }

      try {
        if (this.editedItem.id) {
          await axios.put(`${BASE_URL}/kegiatan/${this.editedItem.id}`, formData);
        } else {
          await axios.post(`${BASE_URL}/kegiatan`, formData);
        }
        this.fetchKegiatan();
        this.clearForm();
        alert("Berhasil!");
      } catch (e) {
        alert("Gagal menyimpan!");
      } finally {
        this.loading = false;
      }
    },

    async deleteItem(item) {
      if (confirm(`Hapus kegiatan ${item.nama_kegiatan}?`)) {
        try {
          await axios.delete(`${BASE_URL}/kegiatan/${item.id}`);
          this.fetchKegiatan();
        } catch (e) {
          alert("Gagal hapus!");
        }
      }
    },
  },
};
</script>

<style scoped>
.cyber-agenda {
  background: transparent;
}
.cyber-text {
  letter-spacing: 2px;
  color: white !important;
  text-shadow: 0 0 10px rgba(1, 140, 116, 0.5);
}
.secondary-text {
  color: #cfa22d !important;
}

.glass-card {
  background: rgba(0, 20, 18, 0.9) !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(1, 140, 116, 0.3) !important;
}
.date-picker-wrapper {
  border: 1px solid rgba(1, 140, 116, 0.5);
  background: #000;
}
.cyber-datepicker >>> .v-picker__title {
  display: none;
}

.map-container-mini {
  position: relative;
  border: 1px solid #018c74;
  overflow: hidden;
}
.mini-map {
  height: 250px;
  width: 100%;
}
.map-overlay-grid {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: linear-gradient(rgba(1, 140, 116, 0.05) 1px, transparent 1px),
    linear-gradient(90deg, rgba(1, 140, 116, 0.05) 1px, transparent 1px);
  background-size: 20px 20px;
  pointer-events: none;
  z-index: 10;
}

.cyber-table {
  background: transparent !important;
}
.cyber-table >>> th {
  background: rgba(1, 140, 116, 0.15) !important;
  color: #cfa22d !important;
}
.avatar-stack {
  display: flex;
  padding-left: 10px;
}
.stack-item {
  margin-left: -10px;
  border: 2px solid #018c74;
  transition: 0.3s;
}
.stack-item:hover {
  transform: translateY(-5px);
  z-index: 10;
}

.cyber-save-btn {
  color: #002d25 !important;
  font-weight: 900 !important;
  letter-spacing: 1px;
}
.cyber-input-highlight >>> input {
  color: #cfa22d !important;
  font-weight: bold;
}
.glow-hover:hover {
  filter: drop-shadow(0 0 8px currentColor);
  transform: scale(1.1);
}

.cyber-page,
.cyber-container,
.cyber-portal {
  background: transparent !important;
}

.cyber-title,
.cyber-text,
.cyber-id,
.cyber-desc,
.cyber-item-text {
  color: #1c2b28 !important;
  text-shadow: none !important;
}

.secondary-text {
  color: #018c74 !important;
  text-shadow: none !important;
}

.glass-card,
.cyber-card,
.cyber-dialog,
.cyber-dialog-card,
.cyber-modal,
.cyber-map-container,
.cyber-mapping-container,
.cyber-news-container,
.cyber-moments,
.cyber-carousel,
.cyber-agenda,
.cyber-sosmed-header,
.cyber-map-box,
.cyber-map {
  background: #ffffff !important;
  border: 1px solid #eef1f0 !important;
  backdrop-filter: none !important;
  color: #1c2b28 !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04) !important;
}

.dialog-header,
.dialog-header-gradient {
  background: #f4f7f6 !important;
  color: #1c2b28 !important;
  border-bottom: 1px solid #eef1f0 !important;
}

.dialog-header .white--text,
.dialog-header-gradient .white--text,
.cyber-dialog .white--text,
.cyber-dialog-card .white--text {
  color: #1c2b28 !important;
}

.dialog-neon-line,
.neon-line {
  background: linear-gradient(90deg, #018c74, #cfa22d, #018c74) !important;
}

.transparent-table,
.cyber-table,
.transparent-tabs {
  background: #ffffff !important;
  color: #1c2b28 !important;
}

.transparent-table >>> th,
.cyber-table >>> th {
  background: #f4f7f6 !important;
  color: #018c74 !important;
  font-weight: 800;
  border-bottom: 2px solid #018c74 !important;
}

.transparent-table >>> td,
.cyber-table >>> td {
  color: #1c2b28 !important;
  border-bottom: 1px solid #eef1f0 !important;
}

.transparent-table >>> .v-data-table__empty-wrapper,
.cyber-table >>> .v-data-table__empty-wrapper {
  color: #9aa6a3 !important;
}

.cyber-input,
.cyber-field,
.cyber-search,
.cyber-search-field,
.cyber-search-bar,
.cyber-input-mini,
.cyber-input-dense,
.cyber-input-highlight,
.cyber-input-coord,
.cyber-coord-field,
.cyber-select-dense,
.cyber-file-input,
.cyber-datepicker {
  color: #1c2b28 !important;
}

.cyber-input >>> .v-input__control,
.cyber-field >>> .v-input__control,
.cyber-search >>> .v-input__control,
.cyber-search-field >>> .v-input__control,
.cyber-search-bar >>> .v-input__control,
.cyber-input-mini >>> .v-input__control,
.cyber-input-dense >>> .v-input__control,
.cyber-input-highlight >>> .v-input__control,
.cyber-input-coord >>> .v-input__control,
.cyber-coord-field >>> .v-input__control,
.cyber-select-dense >>> .v-input__control,
.cyber-file-input >>> .v-input__control,
.cyber-datepicker >>> .v-input__control {
  background: #ffffff !important;
  border-radius: 10px;
}

.cyber-input >>> input,
.cyber-field >>> input,
.cyber-search >>> input,
.cyber-search-field >>> input,
.cyber-search-bar >>> input,
.cyber-input-mini >>> input,
.cyber-input-dense >>> input,
.cyber-input-coord >>> input,
.cyber-coord-field >>> input,
.cyber-datepicker >>> input,
.cyber-input >>> .v-label,
.cyber-field >>> .v-label,
.cyber-search >>> .v-label,
.cyber-search-field >>> .v-label,
.cyber-search-bar >>> .v-label,
.cyber-select-dense >>> .v-label,
.cyber-datepicker >>> .v-label {
  color: #1c2b28 !important;
}

.cyber-btn-add,
.cyber-add-btn,
.cyber-add-sosmed-btn {
  background: linear-gradient(135deg, #018c74 0%, #02b395 100%) !important;
  color: #ffffff !important;
  font-weight: 700;
  border: none !important;
  box-shadow: 0 8px 20px rgba(1, 140, 116, 0.25) !important;
}

.cyber-btn-save,
.cyber-save-btn {
  background: #018c74 !important;
  color: #ffffff !important;
  font-weight: 700 !important;
  box-shadow: 0 8px 20px rgba(1, 140, 116, 0.25) !important;
}

.icon-scan-box,
.icon-scan-frame,
.preview-container,
.preview-hex-frame,
.preview-mini-frame,
.preview-scanner {
  background: #f4f7f6 !important;
  border: 1px solid #eef1f0 !important;
}

.preview-tag {
  background: #eaf6f3 !important;
  color: #018c74 !important;
  border: 1px solid rgba(1, 140, 116, 0.3) !important;
}

.scan-overlay {
  display: none !important;
}

.shadow-glow,
.shadow-glow-gold,
.shadow-glow-teal {
  box-shadow: 0 6px 16px rgba(1, 140, 116, 0.15) !important;
}

.action-glow.edit-btn,
.action-glow.delete-btn {
  background: transparent !important;
}


.v-data-table >>> .white--text {
  color: #1c2b28 !important;
}
.plain-description {
  color: #4a5a57 !important;
}

</style>
